"use strict";

exports.__esModule = true;
exports.GridWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _GridElement = require("./GridElement");
var _GridFields = require("./GridFields");
var _GridThumbnail = require("./GridThumbnail");
var _EditableGridElement = require("./EditableGridElement");
var _GridHeader = require("./GridHeader");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var GridWidget = exports.GridWidget = {
  name: "Grid",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "GridWidget.label",
    defaultMessage: "Grid"
  }),
  icon: "heat-grid",
  createElement: function createElement(props) {
    return {
      type: "Grid",
      props: Object.assign({
        width: 1024,
        height: 768,
        rowCount: 12,
        columnCount: 12
      }, props),
      children: []
    };
  },
  showInPalette: false,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["backgroundColor", "backgroundColorSource", "padding"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 200,
      min: 256,
      max: 3840
    },
    height: {
      "default": 150,
      min: 256,
      max: 2160
    }
  },
  components: {
    Header: _GridHeader.GridHeader,
    Element: _GridElement.GridElement,
    Fields: _GridFields.GridFields,
    Thumbnail: _GridThumbnail.GridThumbnail,
    Editable: _EditableGridElement.EditableGridElement
  }
};